import { getAction, postAction, deleteAction, putAction } from '../http'

//code
export default {
    list: ( params = {} ) => getAction('/api/design/viewUserProject/list', params),
    viewUserDepart: ( params = {} ) => getAction('/api/design/viewUserDepart/list', params),

    //查询所有
    getAllUsr: params => getAction('/api/design/sysUser/list',params),

    //添加成员
    addMember: ( params = {} ) => postAction('/api/design/project_user/add', params),
    //删除
    delMember: ( params = {} ) => deleteAction('/api/design/project_user/delete', params),
    //修改
    editMember: ( params = {} ) => putAction('/api/design/project_user/edit', params),
}